<template>
  <div class="container">
    <div class="searchType" v-if="localshowSearchView">
      <div class="value">
        <div class="createdStyles">
          <div class="openedStyles">
            <div>
              <button
                class="k-icon k-button-icon k-i-x"
                style="float: right; border: none; background: none"
                @click="hideSearchView"
              ></button>
            </div>
          </div>
          <label class="label" for="searchResult">{{ $t("searchView.searchResult") }}</label>
          <div class="searchedStylesData row" style="min-height: 50px; padding: 10px">
            <div class="name column" v-for="style in searchedStylesData" :key="style.id">
              <a href="javascript:void(0)" @click="openStyle(style.id)" style="font-size: 12px">{{ style.name }}</a>
            </div>
          </div>
          <hr style="width: 100%; text-align: left; margin-left: 0" />
          <label class="label" for="recentlyCreatedStyles">{{ $t("searchView.recentlyCreatedStyles") }}</label>
          <div class="styles" style="padding: 10px">
            <div class="styleData row" style="min-height: 50px">
              <div class="data column" v-for="data in shortStyleList" :key="data.id">
                <a href="javascript:void(0)" @click="openStyle(data.id)" style="font-size: 12px">{{ data.name }}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import EditStyle from "../_components/EditStyle.vue";
import { StyleApi } from "@/api";
import { defineComponent } from "vue";

export default defineComponent({
  name: "searchView",
  components: {
    EditStyle
  },
  emits: ["getEditStyleId", "setVisibleEdit", "updateSearchView"],
  setup() {
    const styleApi = new StyleApi()!;
    return {
      styleApi
    };
  },
  data() {
    return {
      shortStyleList: [] as any,
      localshowSearchView: this.showSearchView
    };
  },
  props: {
    showSearchView: null,
    stylesData: null as any,
    searchedStylesData: null as any
  },
  created(): void {
    this.shortStyleList = this.stylesData.slice(0, 10);
  },
  methods: {
    openStyle(id: number): void {
      this.$emit("getEditStyleId", id);
      this.$emit("setVisibleEdit", true);
    },
    hideSearchView(): void {
      this.localshowSearchView = false;
      this.$emit("updateSearchView", this.localshowSearchView);
    }
  }
});
</script>
<style scoped>
.searchType .k-overlay {
  display: none;
}
.column {
  width: 33%;
  padding: 4px;
}
.column a {
  color: #000000;
}
.searchType {
  position: absolute;
  top: 46px;
  left: 49px;
  width: 100%;
  height: auto;
  background-color: #fff;
  box-shadow: 0 0 10px #000000 !important;
  border-color: rgba(0, 0, 0, 0.08);
  color: #424242;
  padding: 20px;
  border-radius: 5px;
}
.label {
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 0px !important;
}
</style>
